module.exports = __webpack_public_path__ + "static/img/图片 62.0fc0821.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/图片 62.png
// module id = mOdP
// module chunks = 1